import algoliasearch from 'algoliasearch';
import { supabase } from './supabase';

// Get environment variables with fallbacks for Node.js environment
const algoliaAppId = typeof import.meta !== 'undefined' 
  ? import.meta.env.VITE_ALGOLIA_APP_ID 
  : process.env.VITE_ALGOLIA_APP_ID || process.env.ALGOLIA_APP_ID;

const algoliaAdminKey = typeof import.meta !== 'undefined'
  ? import.meta.env.VITE_ALGOLIA_ADMIN_KEY
  : process.env.VITE_ALGOLIA_ADMIN_KEY || process.env.ALGOLIA_ADMIN_KEY;

// Check if Algolia credentials are available
const hasAlgoliaCredentials = algoliaAppId && algoliaAdminKey;

// Initialize Algolia client if credentials are available
let algoliaClient: any = null;
if (algoliaAppId && algoliaAdminKey) {
  algoliaClient = algoliasearch(algoliaAppId, algoliaAdminKey);
}

export async function handlePostUpdate(post: any) {
  try {
    // Skip if Algolia is not configured
    if (!hasAlgoliaCredentials) {
      console.warn('Algolia credentials not found. Skipping search index update. Check your .env file.');
      return;
    }

    const index = algoliaClient.initIndex('blog_posts');

    // Fetch the post with related data
    const { data: post, error: postError } = await supabase
      .from('blog_posts')
      .select(`id, title, slug, excerpt, meta_title, meta_description, meta_keywords, 
               published_at, updated_at, read_time, deleted, is_published,
               blog_authors (id, name, slug),
               blog_categories (id, name, slug),
               blog_tag_posts (blog_tags (id, name, slug))`)
      .eq('id', postId)
      .single();

    if (error) throw error;

    // Extract tags
    const tags = post.blog_tag_posts
      ? post.blog_tag_posts.map(tagPost => tagPost.blog_tags.name)
      : []; 

    // Create the record
    const record = {
      objectID: post.id,
      title: post.title,
      slug: post.slug,
      excerpt: post.excerpt,
      content_preview: post.excerpt || '',
      meta_title: post.meta_title,
      meta_description: post.meta_description,
      meta_keywords: post.meta_keywords,
      published_at: post.published_at,
      updated_at: post.updated_at,
      read_time: post.read_time,
      deleted: post.deleted,
      is_published: post.is_published,
      author: post.blog_authors ? post.blog_authors.name : null,
      author_slug: post.blog_authors ? post.blog_authors.slug : null,
      category: post.blog_categories ? post.blog_categories.name : null,
      category_slug: post.blog_categories ? post.blog_categories.slug : null,
      tags: tags,
      url: `/blog/${post.slug}`
    };

    // Save to Algolia
    await index.saveObject(record);
    console.log(`Successfully updated post ${post.id} in search index`);
  } catch (error) {
    console.error('Error updating search index:', error);
  }
}